import React from "react";
import { Box, Typography, Chip, useTheme } from "@mui/material";
import { formatTime } from "./utils";

interface VideoTrimInfoProps {
  trimStart: number;
  trimEnd: number;
  duration: number;
}

const VideoTrimInfo: React.FC<VideoTrimInfoProps> = ({
  trimStart,
  trimEnd,
  duration,
}) => {
  const theme = useTheme();
  const trimDuration = trimEnd - trimStart;
  const percentSelected = Math.round((trimDuration / duration) * 100);

  return (
    <Box
      sx={{
        mt: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box>
        <Typography variant="caption" color="text.secondary" display="block">
          Start:{" "}
          <span style={{ color: theme.palette.primary.main, fontWeight: 600 }}>
            {formatTime(trimStart)}
          </span>
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block">
          End:{" "}
          <span style={{ color: theme.palette.primary.main, fontWeight: 600 }}>
            {formatTime(trimEnd)}
          </span>
        </Typography>
      </Box>

      <Box>
        <Chip
          label={`Duration: ${formatTime(trimDuration)} (${percentSelected}%)`}
          size="small"
          color="primary"
          variant="outlined"
        />
      </Box>
    </Box>
  );
};

export default VideoTrimInfo;
